export const FAX_NUMBER_MASK_REGEXP = /^(\d{0,3})(\d{0,3})(\d{0,4})/;
